import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './delivery-icon.svg'
import _imports_1 from './delivery-icon-2.svg'
import _imports_2 from './refund-icon.svg'
import _imports_3 from 'odendo-image-resizer?module!./charity-ikon1.png?height=92'



export default /*@__PURE__*/_defineComponent({
  __name: 'usp',
  props: {
    auction: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['usp-container'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style['usp'], 'content-width'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['item'])
      }, [
        _createElementVNode("img", {
          class: _normalizeClass([_ctx.$style['icon'], _ctx.$style['icon-white-bg']]),
          "data-no-block": "",
          src: _imports_0,
          width: "60",
          height: "60"
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['text'])
        }, "Fragt " + _toDisplayString(__props.auction ? "49" : "49") + " kr.", 3 /* TEXT, CLASS */)
      ], 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['item'])
      }, [
        _createElementVNode("img", {
          class: _normalizeClass([_ctx.$style['icon'], _ctx.$style['icon-white-bg']]),
          "data-no-block": "",
          src: _imports_1,
          width: "60",
          height: "60"
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['text'])
        }, " Levering " + _toDisplayString(__props.auction ? "2-4" : "1-2") + " dage ", 3 /* TEXT, CLASS */)
      ], 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['item'])
      }, [
        _createElementVNode("img", {
          class: _normalizeClass([_ctx.$style['icon'], _ctx.$style['icon-white-bg']]),
          "data-no-block": "",
          src: _imports_2,
          width: "60",
          height: "60"
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['text'])
        }, "30 dages returret", 2 /* CLASS */)
      ], 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style['item'], _ctx.$style['item-about']])
      }, [
        _createElementVNode("img", {
          class: _normalizeClass(_ctx.$style['icon']),
          "data-no-block": "",
          src: _imports_3,
          width: "92",
          height: "92"
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['text'])
        }, [
          _createElementVNode("strong", {
            class: _normalizeClass(_ctx.$style['header'])
          }, "Sammen støtter vi velgørende projekter!", 2 /* CLASS */),
          _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
          _cache[1] || (_cache[1] = _createTextVNode(" Odendo handler ikke kun om forretning; vi er stolte af vores sociale engagement. ")),
          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
          _cache[3] || (_cache[3] = _createTextVNode(" Gennem vores mange ")),
          _cache[4] || (_cache[4] = _createElementVNode("a", { href: "/udloeber-snart/velgoerenhedsauktioner" }, "velgørenhedsauktioner", -1 /* HOISTED */)),
          _cache[5] || (_cache[5] = _createTextVNode(" er vores fantastiske brugere med til at gøre en kæmpe forskel. "))
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

})